import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  box-shadow: 0px 1px 3px #00000029;
  background: #FFFFB5;
  padding: 20px;
  min-height: 40px;
  margin-bottom: 20px;
  border-radius: 10px;
  width: 100%;
  position: relative;
`

export const Loading = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ContentMessage = styled.div`
  display: flex;
  margin-top: 6px;

  > p {
    line-height: 2rem;
  }

  @media (max-width: 768px) {
    max-width: 290px;
  }
`

export const ContentSelectedWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;

  > svg {
    cursor: pointer;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  align-self: flex-end;
  gap: 20px;

  > button {
    height: 36px;
    padding: 0 20px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    flex-direction: column-reverse;
    gap: 10px;
    align-items: flex-end;

    > button:nth-child(1) {
      padding: 0;
    }
  }
`